export default class CustomPaletteProvider {
  private translate: any;

  static $inject = ['palette', 'translate'];

  constructor(palette: any, translate: any) {
    this.translate = translate;
    palette.registerProvider(this);
  }

  getPaletteEntries() {
    return {
      'color-picker': {
        group: 'tools',
        className: 'custom-icon-color',
        title: this.translate('Change Color'),
        action: {
          click: () => {
            const event = new CustomEvent('open-color-picker');
            window.dispatchEvent(event);
          },
        },
      },
    };
  }
}
